import { start } from 'qiankun'
import { onMounted, ref } from 'vue'

export const useQiankun = () => {
  const startQiankun = () => {
    if (!window.isQiankunStart) {
      window.isQiankunStart = true
      start({
        prefetch: true,
        sandbox: { speedy: true },
        singular: false, // 是否为单实例场景，单实例指的是同一时间只会渲染一个微应用
      })
    }
  }

  onMounted(() => {
    startQiankun()
  })

  return {
    startQiankun,
  }
}
